import { Button } from "@material-ui/core";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import Fab from "@material-ui/core/Fab";
import { makeStyles } from "@material-ui/core/styles";
import { PhoneOutlined } from "@material-ui/icons";
import React from "react";
import AppConfig from "../../AppConfig";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "2rem 2rem 2rem 2rem",
    background: "#fff",
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
    borderRadius: "0.5rem",
    zIndex: "100",
    position: "fixed",
    bottom: "0",
  },
  btnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "row-reverse",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "row-reverse",
      justifyContent: "center",
      alignItems: "center",
      gap: "0.5rem",
      width: "100%",
      margin: "0rem 0rem 0.5rem 0rem",
    },
  },
  primaryButton: {
    padding: "0.5rem 1rem 0.5rem 1rem",
    background: "#A8626C",
    color: "#FFFFFF",
    margin: "1.5rem 0rem 0rem 0rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "capitalize",
    borderRadius: "0.75rem",
    "&:hover": {
      background: "#95565F",
    },
    "&:active": {
      background: "#A8626C",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: "0.875rem",
      margin: "0.5rem 0rem 0rem 0rem",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      margin: "0.5rem 0rem 0rem 0rem",
      fontSize: "0.875rem",
    },
  },
  secondaryButton: {
    background: "#6934711F",
    color: "#5b2173",
    borderRadius: "0rem",
    border: "solid 1px #5b2173",
    margin: "1.5rem 0rem 0rem 0rem",
    padding: "0.5rem 1rem 0.5rem 1rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "capitalize",
    borderRadius: "0.75rem",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      margin: "0.5rem 0rem 0rem 0rem",
      fontSize: "0.875rem",
      background: "#6934711F",
    },
  },
  fabWhatsapp: {
    background: "linear-gradient(to right, #0FCA56 0%, #08A945 100%)",
    color: "#FFFFFF",
    margin: "0rem 0rem 0rem 0.5rem",
    borderRadius: "0.5rem",
  },
}));

const BottomNavHalcyon = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  //   const [showNumber, setShowNumber] = useState(false);

  //   const handleViewNumber = () => {
  //     setShowNumber(true);
  //   };
  const getWhatsAppLink = () => {
    const baseNumber = "919513689999";
    const message = "Hi, I'm interested in Heavie Halcyon project. Please share more details.";
    return `https://wa.me/${baseNumber}?text=${encodeURIComponent(message)}`;
  };
  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      className={classes.root}
    >
      <div className={classes.btnRow}>
        {/* {!showNumber ? (
          <Button
            variant="outlined"
            onClick={handleViewNumber}
            title="View Number"
            rel="noopener"
            className={classes.primaryButton}
            startIcon={<PhoneOutlined />}
          >
            View Number
          </Button>
        ) : (
          <Button
            variant="outlined"
            href={`tel:08071844962`}
            title="Call Now"
            rel="noopener"
            className={classes.primaryButton}
            startIcon={<PhoneOutlined />}
          >
            08071844962
          </Button>
        )} */}
        <Button
          variant="outlined"
          href={`tel:08071844962`}
          title="Call Now"
          rel="noopener"
          // onClick={handleOpenVisit}
          className={classes.primaryButton}
          startIcon={<PhoneOutlined />}
        >
          Call Now
        </Button>
      </div>
      <div>
        <Fab
          className={classes.fabWhatsapp}
          size="small"
          color="primary"
          aria-label="Whatsapp"
          href={getWhatsAppLink()}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            alt={AppConfig.imageAltText}
            loading="lazy"
            referrerPolicy="no-referrer"
            height={28}
            width={28}
            style={{ padding: "0.25rem" }}
            src="/images/icons/social/whatsapp-white.svg"
          />
        </Fab>
      </div>
    </BottomNavigation>
  );
};

export default BottomNavHalcyon;
